import React from 'react';
import { IconButton } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import * as icons from 'mdi-material-ui';

const useStyles = makeStyles(theme => ({
    tableIcons: {
        width: 35,
    },
    checkmark: {
        color: `${theme.palette.success.main}`,
    },
}));

export const TableRowButtons = ({ index, removeRow }) => {
    const classes = useStyles();

    return (
        <td className={classes.tableIcons}>
            <IconButton size="small" id={index} onClick={removeRow}>
                <icons.Delete />
            </IconButton>
        </td>
    );
};
